export enum DEPARTMENT_ROUTE_NAMES {
  DEPARTMENT_INDEX = "department-index",
  DEPARTMENT_NEW = "department-new",
  DEPARTMENT_EDIT = "department-edit",
  DEPARTMENT_VIEW = "department-view",
}
